export default __webpack_public_path__ + "static/media/iclmLogo.82e4861e.jpeg";